import React from 'react';

const MenuItem = ({translate, label, href, hidden = false, active = false}) => {
	return hidden ? null : (
		<li
			className={['menu-smooth-scroll', (active ? 'active' : '')].join(' ')}>
			<a href={`#${href}`} data-section={`#${href}`}>{translate(label)}</a>
		</li>
	);
};

export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/elements/MenuItem.js